import riot from 'riot';

import './Triggerable';
import './Triggerer';

export const required = (e = 'Missing parameter') => {
	throw e;
};

export const observer = riot.observable();